var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lify-divider",class:[_vm.center ? 'center' : '', _vm.colorType === 'green' ? 'green' : ''],style:({ width: _vm.width })})
}
var staticRenderFns = []

export { render, staticRenderFns }